import type { MediaKitAsset } from '../../lib/api/operatorConsole';

const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

export function formatUsd(amount: number): string {
  return Number.isFinite(amount) ? USD.format(amount) : '—';
}

const UNITS = ['KB', 'MB', 'GB'] as const;

/** Binary units, one decimal from MB up: 2 481 123 → "2.4 MB". */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return '—';
  if (bytes < 1024) return `${bytes} B`;
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return unit === 0 ? `${Math.round(value)} KB` : `${value.toFixed(1)} ${UNITS[unit] ?? 'GB'}`;
}

/** "Photo 1 · 3000×4200 · 2.4 MB"; no resolution until the blob is analyzed. */
export function assetButtonLabel(asset: MediaKitAsset): string {
  const parts = [asset.label];
  if (asset.width && asset.height) parts.push(`${asset.width}×${asset.height}`);
  parts.push(formatBytes(asset.byte_size));
  return parts.join(' · ');
}

export function topCardsLabel(count: number): string {
  return count === 1 ? '1 top card' : `${count} top cards`;
}
